import WebApiService from "@/services/webapi.service.js";
import Utente from "@/models/Utente/utente.model.js";
import LoginData from "@/models/Utente/loginData.model.js";
import IndirizziSpedizione from "@/models/Utente/indirizziSpedizione.model";
import DatiLoginUtente from "@/models/Utente/datiLoginUtente.model.js";
import DatiCompany from "@/models/Utente/datiCompany.model";

const state = {
    utente: null,
    lingua: null
}

const getters = {

    getUtente: (state) => {
        let utente = state.utente;
        if(!utente){
            let u = sessionStorage.getItem("utente-Wikini");
            if(u != null){
                utente = JSON.parse(new Buffer.from(u, 'base64').toString('ascii'));
            }else{
                return null;
            }
        }      
        return utente;
    },
    getNomeUtente: (state) => {
        let utente = state.utente;
        if(!utente){
            utente = JSON.parse(new Buffer.from(sessionStorage.getItem("utente-Wikini") ?? "", 'base64').toString('ascii'));
        }      
        if(utente.DatiUtente)
            return utente.DatiUtente.Nome;

        return "";
    },
    getIndirSped: (state)=> {
        let utente = state.utente;
        if(!utente){
            utente = JSON.parse(new Buffer.from(sessionStorage.getItem("utente-Wikini") ?? " ", 'base64').toString('ascii'));
        }
        return utente.IndirizziSpedizione;
    },
    getIndirFattu: (state)=> {
        let utente = state.utente;
        if(!utente){
            let u = sessionStorage.getItem("utente-Wikini");
            if(u != null){
                utente = JSON.parse(new Buffer.from( u, 'base64').toString('ascii'));
                return utente?.IndirizziFatturazione ?? "-";
            }else{
                return "-";
            }
        }
    },
    isLoggedIn:(state) =>{
        let utente = sessionStorage.getItem("utente-Wikini");
        if(utente != null || state.utente != null){
            return true;
        }
        return false;
    },
    getLinguaUtente: (state) => {
        let utente = state.utente;
        if(!utente){
            let u = sessionStorage.getItem("utente-Wikini");
            if(u != null){
                utente = JSON.parse(new Buffer.from( u, 'base64').toString('ascii'));
            }else{
                return "IT"
            }
        }
        if(utente.DatiLoginUtente && utente.DatiLoginUtente.CodLang){
            return utente.DatiLoginUtente.CodLang;
        }else{
            return "-";
        }
    },
    getLinguaNoLogin: (state) =>{
        let lingua = state.lingua;
        if(lingua){
            let lang = sessionStorage.getItem("lingua");
            if(lang != null){
                lingua = JSON.parse(new Buffer.from(lang ?? " ", 'base64').toString('ascii'));
            }else{
                return "IT";
            }
        }
        if(lingua){
            return lingua;
        }else{
            return "IT";
        }
    }
}

const mutations = {

    setUtente: (state, utente) => {
        utente.DatiLoginUtente.CodLang = "IT";
        state.utente = utente;
        sessionStorage.setItem("utente-Wikini", Buffer.from(JSON.stringify(utente)).toString("base64"));        
    },
    setLangUtente: (state, data) =>{
        data.utente.DatiLoginUtente.CodLang = data.CodiceLingua;
        state.utente = data.utente;
        sessionStorage.setItem("utente-Wikini", Buffer.from(JSON.stringify(state.utente)).toString("base64"));    
    },
    setLangNoLogin: (state,data) =>{
        state.lingua = data.CodiceLingua;
        sessionStorage.setItem("lingua", Buffer.from(JSON.stringify(state.lingua)).toString("base64"));     
    },
    setDettagliLoginUtente: (state, dettagliUtente) => {   
        let utente = state.utente;
        if(!utente){
            utente = JSON.parse(new Buffer.from(sessionStorage.getItem("loginutente"), 'base64').toString('ascii'));
        }        
        utente.DatiUtente = dettagliUtente;
        state.utente = utente;
        sessionStorage.setItem("loginutente", Buffer.from(JSON.stringify(utente)).toString("base64"));     
    },

    setIndirizziSpedizione: (state, indirizzi) => {   
        let utente = state.utente;
        if(!utente){
            utente = JSON.parse(new Buffer.from(sessionStorage.getItem("utente-Wikini"), 'base64').toString('ascii'));
        }        
        utente.IndirizziSpedizione = indirizzi;
        state.utente = utente;
        sessionStorage.setItem("utente-Wikini", Buffer.from(JSON.stringify(utente)).toString("base64"));     
    },
    setIndirizziFatturazione: (state, indirizzi) => {   
        let utente = state.utente;
        if(!utente){
            utente = JSON.parse(new Buffer.from(sessionStorage.getItem("utente-Wikini"), 'base64').toString('ascii'));
        }        
        utente.IndirizziFatturazione = indirizzi;
        state.utente = utente;
        sessionStorage.setItem("utente-Wikini", Buffer.from(JSON.stringify(utente)).toString("base64"));     
    },
    resetUser: (state) =>{
        state.utente = null;
        sessionStorage.clear();
        
    }
}

const actions = {

    login: ({commit}, user) => {     
        let loginData = new LoginData(user.username, user.password,process.env.VUE_APP_COD_SHOP);
        return WebApiService.login('account/login', user.apikey, loginData).then(
        (data) => {    
                if(data.StatusCode !== 200){
                    return [false, data.Message];
                }
                else{
                    let utente = new Utente();
                    Object.assign(utente.DatiLoginUtente = new DatiLoginUtente(), data.Data);
                    Object.assign(utente.DatiCompany = new DatiCompany(),data.Data.Company);
                    commit("setUtente", utente);
                    return [true, ""];            
                }
            },
            error => {  
                return [false, error];
            }
        )
        .catch(
            error => {return [false, error];}
        );
    },
    SetIndirSpedAPi: ({commit}, data) => {
        return WebApiService.get("Utente/DatiSpedizione", data.Token).then(
            (data) =>{
                if(data) {
                    let Indir = data.Data.map(o => {
                        return Object.assign(new IndirizziSpedizione(), o)
                    });
                    commit("setIndirizziSpedizione",Indir);
                }
            }
        ).catch(
            error => {return [false, error];}
        );
    },
    SetIndirFattuAPi: ({commit}, data) => {
        return WebApiService.get("Utente/DatiFatturazione", data.Token).then(
            (data) =>{
                if(data) {
                    let Indir = data.Data.map(o => {
                        return Object.assign(new IndirizziSpedizione(), o)
                    });
                    commit("setIndirizziFatturazione",Indir);
                }
            }
        ).catch(
            error => {return [false, error];}
        );
    },
    CheckLogin:({commit},data) =>{
        return WebApiService.get("Account/CheckSessione",data.Token).then(
            (data) =>{
                if(data) {
                    if(data.StatusCode == 401){
                        commit("resetUser");
                        return false;
                    }
                    return true;
                    //return true;
                }else{
                    commit("resetUser");
                    return false;
                }
            }
        );
    },
    resetUtente: ({commit}) =>{
        return commit("resetUser");
    },
    SetLangUtente: ({commit},data) =>{
        return commit("setLangUtente",data);
    },
    SetLangNoLogin: ({commit},data) =>{
        return commit("setLangNoLogin", data);
    }
}

export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}